// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/modules/notion/use-cases/status.ts"
);
import.meta.hot.lastModified = "1735915731235.1199";
}
// REMIX HMR END

import { StatusEntity } from '../entities/status';

export async function fetchStatusEntriesUseCase(): Promise<StatusEntity[]> {
	const response = await fetch(
		'https://m.screenwork.de/n8n/webhook/bd2fe479-b1a0-4932-847c-923bd540c401',
		{
			method: 'GET',
			cf: {
				cacheTtl: 30,
				cacheEverything: true,
			},
		}
	);

	const body = await response.json();
	let result: StatusEntity[] = [];

	if (Array.isArray(body)) {
		result = body
			.map(entry => {
				let severity: StatusEntity['severity'] = 'low';
				if (entry.priority === 'normal') {
					severity = 'medium';
				} else if (entry.priority === 'urgent' || entry.priority == 'high') {
					severity = 'high';
				}

				let startDate = entry.startDate ? new Date(Number(entry.startDate)) : undefined;
				let endDate = entry.endDate ? new Date(Number(entry.endDate)) : undefined;

				if (startDate && endDate && startDate > endDate) {
					startDate = endDate;
				}

				let status: StatusEntity['status'] = 'open';
				if (entry.status == 'open') {
					status = 'open';
				} else if (entry.status == 'closed') {
					status = 'done';
				} else {
					status = 'working';
				}

				if (status == 'open') {
					if (startDate && startDate < new Date()) {
						status = 'working';
					}
				}

				if (endDate && endDate < new Date()) {
					status = 'done';
				}

				return {
					id: entry.id,
					title: entry.title,
					startDate,
					endDate,
					severity,
					status,
					description: entry.description,
				};
			})
			.filter(e => {
				if (e.status == 'done' && e.endDate) {
					const thirtyDaysAgo = new Date();
					thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
					if (e.endDate < thirtyDaysAgo) {
						return false;
					}
				}

				return true;
			});
	}

	return result;
}
